import './Navigation.scss';

import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';

import { ApplicationContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';

import { IsMobile } from '@/v2/components/utils/DeviceUtils';
import Fade from '@/v2/components/atoms/Fade';
import Header from '@/v2/components/application/Header';
import CarouselSlider from '@/v2/components/layouts/CarouselSlider';

const SLIDE_TRANSITION_SPEED = 1000; // speed in ms

const NavigationComponent = ({ slides, canBeClosed }) => (
    <section className="Navigation">
        <CarouselSlider slides={slides} speed={SLIDE_TRANSITION_SPEED} loop />
        <Header show hideMenu showCloseButton={canBeClosed} />
        <Fade light cover slow />
    </section>
);

const isMobile = IsMobile();

let canBeClosed = false;

if (isMobile) {
    let { referrer } = document;
    if (referrer.slice(-1) === '/') referrer = referrer.substring(0, referrer.length - 1); // trim a '/' if exists

    const previousPage = referrer && referrer.split('/').slice(-1)[0]; // last portion from the URL
    canBeClosed = !!previousPage && previousPage.endsWith('ariya.html');
}

const Navigation = () => {
    const [data] = useContext(ApplicationContext);
    const { state } = useContext(MomentStateContext);

    const updatedData = data?.header?.menu?.items.map((item) => ({
        ...item,
        submenu: item.submenu.map((submenuItem) => ({ ...submenuItem, isVisited: state[submenuItem.name] })),
    }));

    return <NavigationComponent slides={updatedData} canBeClosed={canBeClosed} />;
};

export default withRouter(Navigation);
